import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.chassisHeightState || initialState;

export const selectChassisHeightList = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.list
);

export const selectChassisHeightLoading = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.loading
);

export const selectChassisHeightMeta = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.meta
);

export const selectChassisHeightPage = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.page
);

export const selectChassisHeightPerPage = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.perPage
);

export const selectChassisHeightManufacturerFilter = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.manufacturerFilter
);

export const selectChassisHeightSuspensionTypeFilter = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.suspensionTypeFilter
);

export const selectChassisHeightMasterModelFilter = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.masterModelFilter
);

export const selectChassisHeightYearFilter = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.yearFilter
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.isAddModalOpen
);

export const selectChassisHeightForm = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.form
);

export const selectChassisHeightSaving = createSelector(
  [selectDomain],
  (chassisHeightState) => chassisHeightState.saving
);
